import styled from 'styled-components'
import { COLOR, FONT } from '@farewill/ui/tokens'

const StyledLogo = styled.div`
  align-items: center;
  background: ${COLOR.ACCENT.SECONDARY};
  border-radius: 12px;
  color: ${COLOR.WHITE};
  display: flex;
  font-size: ${FONT.SIZE.S};
  font-weight: ${FONT.WEIGHT.BOLD};
  height: 50px;
  justify-content: center;
  width: 50px;
`

const EightxEightIcon = ({ className }: { className?: string }) => {
  return (
    <StyledLogo role="presentation" className={className}>
      8x8
    </StyledLogo>
  )
}

export default EightxEightIcon
